import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profileData: null,
  profilePost: [],
  profilePostPageNumber: 1,
  profilePostCount: 0,
  profileNft: [],
  profileNftPageNumber: 0,
  profileNftCount: 0,
  isLoadingProfile: true,
};

const profileDataSlice = createSlice({
  name: "profileData",
  initialState: initialState,
  reducers: {
    profileDataReducer(state, action) {
      state.profileData = action.payload;
      state.isLoadingProfile = false;
    },
    profilePostReducer(state, action) {
      state.profilePost = action.payload;
      state.profilePostCount = action.payload[0]?.countPost;
      state.profilePostPageNumber = 1;
    },
    profilePostReducerPlus(state, action) {
      state.profilePost.push(...action.payload);
      state.profilePostPageNumber += 1;
    },
    profileNftReducer(state, action) {
      // console.log("test", action.payload);
      state.profileNft = action.payload;
      state.profileNftCount = action.payload[0]?.countNFT;
      state.profileNftPageNumber = 0;
    },
    profileNftReducerPlus(state, action) {
      state.profileNft.push(...action.payload);
      state.profileNftPageNumber += 1;
    },
    profileLikeUnLikeCommentReducer(state, action) {
      const updatedPost = action.payload;

      // Create a new array by looping through the feed array
      const updatedFeed = state.profilePost.map((post) => {
        // If the post id matches with the updated post id, return the updated post
        if (post._id === updatedPost._id) {
          return updatedPost;
        }
        // Otherwise, return the original post
        return post;
      });

      // Update the state with the updated feed array
      state.profilePost = updatedFeed;
    },
    profileNftLikeUnLikeCommentReducer(state, action) {
      const updatedPost = action.payload;

      // Create a new array by looping through the feed array
      const updatedFeed = state.profileNft.map((post) => {
        // If the post id matches with the updated post id, return the updated post
        if (post._id === updatedPost._id) {
          return updatedPost;
        }
        // Otherwise, return the original post
        return post;
      });

      // Update the state with the updated feed array
      state.profileNft = updatedFeed;
    },
    profileDataReducerReset() {
      return initialState;
    },
  },
});

export const {
  profileDataReducer,
  profilePostReducer,
  profilePostReducerPlus,
  profileNftReducer,
  profileNftReducerPlus,
  profileLikeUnLikeCommentReducer,
  profileNftLikeUnLikeCommentReducer,
  profileDataReducerReset,
} = profileDataSlice.actions;
export default profileDataSlice.reducer;
